import React from 'react';
import Header from '../components/Header/Header';
import CatalogoFooter from '../components/Footer/CatalogoFooter';
import CatalogoNavbar from '../components/Navbar/CatalogoNavbar';
import InstalarApp from '../components/Button/InstalarApp';
import OnlineStatus from '../components/Utils/OnlineStatus';
import LojaRoute from '../context/LojaRoute';
import './MainLayout.css';
import { Outlet } from 'react-router-dom';

const CatalogoLayout = () => { // Recebe o token como prop
    return (
      <LojaRoute>
        <div className="main-layout">
            <Header />
            <CatalogoNavbar/>
            <main className="container">
              <OnlineStatus/>
              <InstalarApp/>
              <Outlet/>
            </main>
            <CatalogoFooter/>
        </div>
      </LojaRoute>
    );
};

export default CatalogoLayout;